export const ALLOWED_PAYPAL_APPROVAL_HOSTS = new Set([
  "www.paypal.com",
  "paypal.com",
  "www.sandbox.paypal.com",
  "sandbox.paypal.com",
]);

export function isAllowedPayPalApprovalUrl(value) {
  try {
    const url = new URL(value);
    return (
      url.protocol === "https:" &&
      ALLOWED_PAYPAL_APPROVAL_HOSTS.has(url.hostname)
    );
  } catch (error) {
    return false;
  }
}

export function buildScrubbedMembershipUrl(pathname, search) {
  const params = new URLSearchParams(search || "");
  params.delete("token");
  params.delete("subscription_id");
  params.delete("PayerID");
  params.delete("ba_token");

  const nextSearch = params.toString();
  return nextSearch ? `${pathname}?${nextSearch}` : pathname;
}
